import React, { useContext, useEffect } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import { BackgroundContext } from '../../libs/BackgroundProvider';
import { useGameContext } from "../../libs/GameProvider";
import SvgButton from '../ui/SvgButton';

interface GameGunpowderFailProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onFinish?: () => void;
}

function GameGunpowderFail(_props: GameGunpowderFailProps) {
  const { playClick } = useContext(AudioContext);
  const { setBg } = useContext(BackgroundContext);
  const { game, dispatch } = useGameContext();

  useEffect(() => {
    setBg('game-gunpowder/game4-fail-background', 'game-gunpowder/game4-fail-background/images');
  }, [game, setBg]);

  return (
    <div className="fullscreen">
      <div className="">
        <button className="button button-back-to-main" onClick={() => { playClick(); dispatch({ type: 'game-cover' }) }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-gunpowder/game4-success-button`} src1=".svg" src2="-select.svg" alt="回到主頁"></SvgButton>
        </button>
      </div>
    </div>
  )
}

export default GameGunpowderFail;
